import 'focus-visible';
import 'fslightbox';
import cssVars          from '@ts/modules/cssVars';
import swiper           from '@ts/modules/swiper';

window.addEventListener('DOMContentLoaded', () : void => {
    cssVars();
    swiper();

    import('@ts/modules/burger')
        .then(modules => modules.burger());

    import('@ts/modules/scrollTo')
        .then(modules => modules.scrollTo());

    import('@ts/modules/popup')
        .then(modules => modules.popup());

    import('@ts/modules/handleParsePhone')
        .then(modules => modules.handleParsePhone());

    import('@ts/modules/phoneEvent')
        .then(modules => modules.phoneEvent());

    import('@ts/modules/cart')
        .then(modules => modules.handleShowCart());
});